
import slugify from 'slugify'
export default {
  props: {
    module: Object,
    group: Object
  },

  data () {
    return {
      isReady: false,
      template: {
        date: {
          label: 'Calendar',
          module: 'calendar'
        }
      }
    }
  },

  computed: {
    _group: {
      set (value) {
        this.$emit('update:group', value)
      },

      get () {
        return this.group
      }
    }
  },

  watch: {
    group: {
      handler (val) {
        // console.log('GROUP C', val)
      },
      deep: true,
      immediate: true
    }
  },

  mounted () {
    if (!this.group) this._group = {}
    this.module.content.slots.forEach(slot => {
      this.template[slugify(slot.content.time, { remove: /[*+~.()'"!:@]/g })] = {
        label: slot.content.time,
        module: 'select-button',
        width: '1/2'
      }
    })
    this.isReady = true
  }
}
